<template>
  <div>
      <div class="row">
          <div class="col-8">
              <div class="text-left section-title" style="padding: 5px;">
                  <span v-if="!isOwner" class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>

                      <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / </span>

                      Expenses and Payments
                  </span>
                  <span v-else class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>

                      <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / {{ propertyName}} </span>


                  </span>
                  <p v-if="isOwner" style="
            font-size: 15px;
            font-family: inherit;
            font-weight: 500;

            text-transform: uppercase;
          ">
                      Expenses and Payments
                  </p>
              </div>
          </div>
          <div class="col-4 add-button-section">
              <div class="text-right" style="padding: 5px;">
                  <!--<span style="margin-right:5px">Add New Unit</span>
            <router-link class="btn btn-table" :to="{
      name: 'property',
      params: { buildingId: buildingId, buildingName: buildingName },
    }"><i class="fas fa-plus"></i></router-link>-->
                  <span @click="exportToPDF()"
                        style="
width: 30px;
height: 30px;
border-radius: 5px;
background-color: #007DFC;
color: white;
display: inline-block;
padding-left: 5px;
padding-right: 5px;
text-align: center;
cursor:pointer;
margin-left:5px;
">
                      <i class="fa fa-file-export" style="margin-top:7px;" aria-hidden="true"></i>
                  </span>
                  <userMenu />
              </div>
          </div>

      </div>

      <div id="revenue-admin">
          <div class="row">
              <graph-reports-totals :building-id="buildingId"
                                    :building-name="buildingName"
                                    :is-owner="isOwner"
                                    :total-income="totalIncome"
                                    :total-expenses="totalExpenses"
                                    :total-cash-deposit="totalCashDeposit"
                                    :total-cash="totalCash"
                                    :property-id="propertyId"
                                    :property-name="propertyName"
                                    :sections-total-income="sectionsTotalIncome"
                                    :sections-total-expenses="sectionsTotalExpenses"
                                    :sections-cash-balance="sectionsCashBalance" />
          </div>
          <div class="row pull-center" style="margin-top: 29px;">
              <div class="col-12 form-group">
                  <span style=" width: 30px; height: 30px; border-radius: 5px; background-color: #007DFC; color: white; display: inline-block; padding-left: 5px; padding-right: 5px; text-align: center; cursor: pointer; ">
                      <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                  </span>

                  <period-select style=" margin-left: -2px !important;" class="select" id="period" name="period" :building-id="buildingId" v-model="period" />
              </div>
          </div>

          <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-4 col-12">
                  <div style="text-align: center; font-size: 24px; margin-bottom: 5px;">
                      <span style="color: #007DFC" class="graph-circle-title"> Total Income </span>
                  </div>
                  <div class="row">
                      <div class="col-md-12">
                          <div class="col-md-9">
                              <span class="progress-legend"
                                    style="background-color: #007DFC;"
                                    :style="{ left: totalCollectedPercentage + '%' }">
                                  {{ totalCollectedPercentage }}%
                              </span>
                          </div>
                          <progress-bar bar-color="#007DFC"
                                        bg-color="#fff"
                                        max="100"
                                        class="col-md-9"
                                        size="medium"
                                        :val="totalCollectedPercentage"></progress-bar>
                          <div class="col-md-3" style="padding-top: 4px;">
                              <span style="
                  text-align: right;
                  font-size: 15px;
                  color: #007DFC;
                  font-weight: bold;
                ">
                                  €{{ $filters.toCurrency(totalCollected) }}
                              </span>
                          </div>
                          <div class="col-md-12" style="padding-top: 0; padding-bottom: 0;">
                              <span style="text-align: left; font-size: 15px; color: #007DFC;">
                                  Collected Income
                              </span>
                          </div>
                      </div>
                      <div class="col-md-12" style="padding-top: 0;">
                          <div class="col-md-9">
                              <span class="progress-legend"
                                    style="background-color: #727272;"
                                    :style="{ left: 100 - totalUncollectedPercentage + '%' }">
                                  {{ totalUncollectedPercentage }}%
                              </span>
                          </div>
                          <progress-bar bar-color="#fff"
                                        bg-color="#727272"
                                        max="100"
                                        class="col-md-9"
                                        size="medium"
                                        :val="100 - totalUncollectedPercentage"></progress-bar>
                          <div class="col-md-3" style="padding-top: 4px;">
                              <span style="
                  text-align: right;
                  font-size: 15px;
                  color: #727272;
                  font-weight: bold;
                ">
                                  €{{ $filters.toCurrency(totalUncollected) }}
                              </span>
                          </div>
                          <div class="col-md-12" style="padding-top: 0;">
                              <span style="text-align: left; font-size: 15px; color: #727272;">
                                  Uncollected Income
                              </span>
                          </div>
                      </div>
                  </div>

                  <!----<div class="row" style="margin-top: 5px;">
                    <div v-for="section in sectionsTotalIncome"
                         :key="section"
                         class="col-md-offset-1 col-md-10"
                         style="padding-bottom: 0px; padding-top: 5px;">
                        <div class="total-income-small"
                             :style="'background:' + section.color"></div>
                        <span style="margin-left: 5px; font-size: 17px;"
                              :style="'color:' + section.color">
                            {{ section.name }}
                        </span>
                        <div style="
                    display: inline-block;
                    width: 100px;
                    padding: 1px;
                    padding-right: 5px;
                    float: right;
                    text-align: right;
                  "
                             :style="'background:' + section.color">
                            <span style="
                      text-align: right;
                      font-size: 15px;
                      color: #fff;
                      font-weight: bold;
                    ">{{ section.amount }}</span>
                        </div>
                    </div>
                </div>-->
              </div>

              <div class="col-md-4 col-12">
                  <div style="text-align: center; font-size: 24px; margin-bottom: 5px;">
                      <span style="#494848" class="graph-circle-title"> Total Expenses </span>
                  </div>
                  <div style="position: relative;">
                      <div class="col-md-12">
                          <div class="col-md-9">
                              <span class="progress-legend"
                                    style="background-color: #727272;"
                                    :style="{ left: totalExpensesPaidPercentage + '%' }">
                                  {{ totalExpensesPaidPercentage }}%
                              </span>
                          </div>
                          <progress-bar bar-color="#727272"
                                        bg-color="#fff"
                                        max="100"
                                        class="col-md-9"
                                        size="medium"
                                        :val="totalExpensesPaidPercentage"></progress-bar>
                          <div class="col-md-3" style="padding-top: 4px;">
                              <span style="
                  text-align: right;
                  font-size: 15px;
                  color: #727272;
                  font-weight: bold;
                ">
                                  €{{ $filters.toCurrency(totalExpensesPaid) }}
                              </span>
                          </div>
                          <div class="col-md-12" style="padding-top: 0; padding-bottom: 0;">
                              <span style="text-align: left; font-size: 15px; color: #727272;">
                                  Expenses Paid
                              </span>
                          </div>
                      </div>
                      <div class="col-md-12" style="padding-top: 0;">
                          <div class="col-md-9">
                              <span class="progress-legend"
                                    style="background-color: #494848;"
                                    :style="{ left: 100 - totalUnpaidExpensesPercentage + '%' }">
                                  {{ totalUnpaidExpensesPercentage }}%
                              </span>
                          </div>
                          <progress-bar bar-color="#fff"
                                        bg-color="#494848"
                                        max="100"
                                        class="col-md-9"
                                        size="medium"
                                        :val="100 - totalUnpaidExpensesPercentage"></progress-bar>
                          <div class="col-md-3" style="padding-top: 4px;">
                              <span style="
                  text-align: right;
                  font-size: 15px;
                  color: #494848;
                  font-weight: bold;
                ">
                                  €{{ $filters.toCurrency(totalUnpaidExpenses) }}
                              </span>
                          </div>
                          <div class="col-md-12" style="padding-top: 0;">
                              <span style="text-align: left; font-size: 15px; color: #494848;">
                                  Unpaid Expenses
                              </span>
                          </div>
                      </div>
                  </div>
                  <!-- <div class="row" style="margin-top: 5px;">
              <div
                v-for="section in sectionsTotalExpenses"
                :key="section"
                class="col-md-offset-1 col-md-10"
                style="padding-bottom: 0px; padding-top: 5px;"
              >
                <div
                  class="total-income-small"
                  :style="'background:' + section.color"
                ></div>
                <span
                  style="margin-left: 5px; font-size: 17px;"
                  :style="'color:' + section.color"
                >
                  {{ section.name }}
                </span>
                <div
                  style="
                    display: inline-block;
                    width: 100px;
                    padding: 1px;
                    padding-right: 5px;
                    float: right;
                    text-align: right;
                  "
                  :style="'background:' + section.color"
                >
                  <span
                    style="
                      text-align: right;
                      font-size: 15px;
                      color: #fff;
                      font-weight: bold;
                    "
                    >{{ section.amount }}</span
                  >
                </div>
              </div>
            </div>-->
              </div>

              <div class="col-md-4 col-12">
                  <div style="text-align: center; font-size: 24px; margin-bottom: 5px;">
                      <span style="color:#727272;" class="graph-circle-title">
                          Cash Balance
                      </span>
                  </div>
                  <div style="position: relative;">
                      <div class="col-md-12">
                          <div class="col-md-9">
                              <span class="progress-legend"
                                    style="background-color: #727272;"
                                    :style="{ left: totalCashDepositPercentage + '%' }">
                                  {{ totalCashDepositPercentage }}%
                              </span>
                          </div>
                          <progress-bar bar-color="#727272"
                                        bg-color="#fff"
                                        max="100"
                                        class="col-md-9"
                                        size="medium"
                                        :val="totalCashDepositPercentage"></progress-bar>
                          <div class="col-md-3" style="padding-top: 4px;">
                              <span style="
                  text-align: right;
                  font-size: 15px;
                  color: #727272;
                  font-weight: bold;
                ">
                                  €{{ $filters.toCurrency(totalCashDeposit) }}
                              </span>
                          </div>
                          <div class="col-md-12" style="padding-top: 0; padding-bottom: 0;">
                              <span style="text-align: left; font-size: 15px; color: #727272;">
                                  Cash Desk
                              </span>
                          </div>
                      </div>
                      <div class="col-md-12" style="padding-top: 0;">
                          <div class="col-md-9">
                              <span class="progress-legend"
                                    style="background-color: #007DFC;"
                                    :style="{ left: totalUncollectedCashPercentage + '%' }">
                                  {{ totalUncollectedCashPercentage }}%
                              </span>
                          </div>
                          <progress-bar bar-color="#007DFC"
                                        bg-color="#fff"
                                        max="100"
                                        class="col-md-9"
                                        size="medium"
                                        :val="totalUncollectedCashPercentage"></progress-bar>
                          <div class="col-md-3" style="padding-top: 4px;">
                              <span style="
                  text-align: right;
                  font-size: 15px;
                  color: #007DFC;
                  font-weight: bold;
                ">
                                  €{{ $filters.toCurrency(totalUncollected) }}
                              </span>
                          </div>
                          <div class="col-md-12" style="padding-top: 0; padding-bottom: 0;">
                              <span style="text-align: left; font-size: 15px; color: #007DFC;">
                                  Uncollected Income
                              </span>
                          </div>
                      </div>
                      <div class="col-md-12" style="padding-top: 0;">
                          <div class="col-md-9">
                              <span class="progress-legend"
                                    style="background-color: #494848;"
                                    :style="{ left: 100 - totalUnpaidExpensesCashPercentage + '%' }">
                                  -{{ totalUnpaidExpensesCashPercentage }}%
                              </span>
                          </div>
                          <progress-bar bar-color="#fff"
                                        bg-color="#494848"
                                        max="100"
                                        class="col-md-9"
                                        size="medium"
                                        :val="100 - totalUnpaidExpensesCashPercentage"></progress-bar>
                          <div class="col-md-3" style="padding-top: 4px; padding-right: 0px;">
                              <span style="
                  text-align: right;
                  font-size: 14px;
                  color: #494848;
                  font-weight: bold;
                ">
                                  €-{{ $filters.toCurrency(totalUnpaidExpenses) }}
                              </span>
                          </div>
                          <div class="col-md-12" style="padding-top: 0; padding-bottom: 0;">
                              <span style="text-align: left; font-size: 15px; color: #494848;">
                                  Unpaid Expenses
                              </span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>



          <total-income :building-id="buildingId"
                        :key="period"
                        :period="period"></total-income>



          <collected style="margin-top:20px"
                     :building-id="buildingId"
                     :key="period"
                     :period="period"
                     :dark="false"></collected>



          <uncollected style="margin-top:20px"
                       :building-id="buildingId"
                       :key="period"
                       :period="period"
                       :dark="false"></uncollected>

          <div style="margin-left: 14px; margin-right: 14px;">
              <expenses style="margin-top:20px"
                        :building-id="buildingId"
                        :key="period"
                        :period="period"></expenses>
          </div>



          <creditors style="margin-top:20px"
                     :building-id="buildingId"
                     :building-name="buildingName"
                     :key="period"
                     :period="period"
                     :dark="false"></creditors>



          <outstanding style="margin-top:20px"
                       :building-id="buildingId"
                       :period="period"
                       :dark="true"></outstanding>
      </div>
  </div>
</template>
<style>
.select {
  border: 1px solid grey !important;
  padding: 0px 0;
  padding-left: 3px;
  margin-left: 2px !important;
  width: 120px;
}
</style>
<script>
import { mapState } from "vuex";
import { authenticationService } from "@/_services";
import { Role } from "@/_helpers";
import html2pdf from "html2pdf.js"
export default {
  beforeCreate() {
    this.buildingId = this.$route.params.buildingId;
   // this.buildingName = this.$route.params.buildingName;
    //  alert(this.buildingId)
  },
  data: function () {
    return {
      period: 1,
      buildingId: 0,
    //  buildingName: "",
      totalIncome: 0,
      totalCollectedPercentage: 0,
      totalUncollectedPercentage: 0,
      totalUncollected: 0,
      totalCollected: 0,
      totalExpenses: 0,
      totalUnpaidExpensesPercentage: 0,
      totalExpensesPaidPercentage: 0,
      totalUnpaidExpenses: 0,
      totalExpensesPaid: 0,
      totalCash: 0,
      totalCashBalance: 0,
      totalCashBalancePercentage: 0,
      totalUnpaidExpensesCashPercentage: 0,
      totalUncollectedCashPercentage: 0,
      totalCashDepositPercentage: 0,
      year: 0,
      totalCashDeposit: 0,
      currentUser: null,
      sectionsTotalIncome: [],
      sectionsTotalExpenses: [],
      sectionsCashBalance: [],
      optionsCollected: {
        text: {
          color: "#000000",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: true,
          hideText: false,
        },
        progress: {
          color: "#007DFC",
          backgroundColor: "#000",
        },
        layout: {
          height: 6,
          width: 240,
          verticalTextAlign: 61,
          horizontalTextAlign: 50,
          zeroOffset: 0,
          progressPadding: 0,
          type: "line",
        },
      },
    };
  },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      //this.fetchStatement();
    },
  },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
  },
  mounted() {
    this.year = new Date().getFullYear();
    
      if(this.$route.params.property != null)
      this.$store.commit('property/SET_CURRENT_PROPERTY', this.$route.params.property)
    if (this.$route.params.propertyId) {
      this.propertyId = this.$route.params.propertyId;
     // this.propertyName = this.$route.params.propertyName;
      this.getProperty();
    } else {
      this.buildingId = this.$route.params.buildingId;
    //  this.buildingName = this.$route.params.buildingName;
      this.fetchStatement();
    }
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      property: (state) => state.property.currentProperty,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null && this.building.name)
        return  this.building.name;
      else if(this.property != null && this.property.buildingName)
        return this.property.buildingName
      return ""
    },
    propertyName(){
      if(this.property != null)
        return  this.property.propertyName;
      return ""
    },
    isOwner() {
      return this.currentUser && this.currentUser.role === Role.Owner;
    },
  },
  methods: {
    numberInCircleSize: function (number) {
      if (number.toString().length <= 5) {
        return 35;
      } else if (
        (number.toString().length > 5) &
        (number.toString().length <= 7)
      ) {
        return 25;
      } else if (
        (number.toString().length > 7) &
        (number.toString().length <= 10)
      ) {
        return 18;
      } else {
        return 14;
      }
    },
    getProperty: function () {
      var request = "/properties/" + this.propertyId;
      this.$http
        .get(request, {
          id: this.propertyId,
        })
        .then((response) => {
          this.buildingId = response.data.buildingId;
          //this.buildingName = response.data.buildingName;
          this.fetchStatement();
        });
    },
    
        exportToPDF() {
    html2pdf(document.getElementById("revenue-admin"), {
        margin: 1,
        filename: "revenue-statement.pdf",
        html2canvas: { scale: 2 },
        enableLinks: false,
        jsPDF: { orientation: 'landscape' }
    });
},
    fetchStatement: function () {
      this.chartData = [];
      var request = "/statement/revenues";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.totalIncome = data.totalIncome;
          this.totalUncollected = data.totalUncollected;
          this.totalCollected = data.totalCollected;
          this.totalExpenses = data.totalExpenses;
          this.totalExpensesPaid = data.totalExpensePayments;
          this.totalUnpaidExpensesCashPercentage;
          this.totalUnpaidExpenses =
            this.totalExpenses - this.totalExpensesPaid;
          this.totalCashDeposit = data.totalCashDeposit;
          this.totalCashBalance = data.totalCashBalance;
          var total = this.totalCollected + this.totalUncollected;
          this.totalCash =
            this.totalCashDeposit +
            this.totalUncollected -
            this.totalUnpaidExpenses;
          this.totalCashBalancePercentage = Math.round(
            (this.totalCashBalance * 100) / this.totalCash
          );

          this.totalCashDepositPercentage = Math.round(
            (this.totalCashDeposit * 100) / this.totalCash
          );

          this.totalUnpaidExpensesCashPercentage = Math.round(
            (this.totalUnpaidExpenses * 100) / this.totalCash
          );

          this.totalUncollectedCashPercentage = Math.round(
            (this.totalUncollected * 100) / this.totalCash
          );
          /*  100 -
            (this.totalCashBalancePercentage +
              this.totalUnpaidExpensesCashPercentage);
          this.totalUncollectedPercentage = Math.round(
            (this.totalUncollected * 100) / total
          );*/

          this.totalUncollectedPercentage = Math.round(
            (this.totalUncollected * 100) / total
          );

          this.totalCollectedPercentage = 100 - this.totalUncollectedPercentage;

          this.totalExpensesPaidPercentage = Math.round(
            (this.totalExpensesPaid * 100) / this.totalExpenses
          );

          this.totalUnpaidExpensesPercentage =
            100 - this.totalExpensesPaidPercentage;

          this.sectionsTotalIncome.push({
            value: this.totalCollectedPercentage,
            color: "#007DFC",
            name: "Collected Income",
            amount: "€" + this.totalCollected.toFixed(2),
          });

          this.sectionsTotalIncome.push({
            value: this.totalUncollectedPercentage,
            color: "#727272",
            name: "Uncollected Income",
            amount: "€" + this.totalUncollected.toFixed(2),
          });

          this.sectionsTotalExpenses.push({
            value: this.totalUnpaidExpensesPercentage,
            color: "#494848",
            name: "Unpaid Expenses",
            amount: "€" + this.totalUnpaidExpenses.toFixed(2),
          });
          this.sectionsTotalExpenses.push({
            value: this.totalExpensesPaidPercentage,
            color: "#727272",
            name: "Expenses Paid",
            amount: "€" + this.totalExpensesPaid.toFixed(2),
          });

          this.sectionsCashBalance.push({
            value: this.totalCashBalancePercentage,
            color: "#727272",
            name: "Available Balance",
            amount: "€" + this.totalCashBalance.toFixed(2),
          });

          this.sectionsCashBalance.push({
            value: this.totalUncollectedCashPercentage,
            color: "#007DFC",
            name: "Uncollected Income",
            amount: "€" + this.totalUncollected.toFixed(2),
          });

          this.sectionsCashBalance.push({
            value: this.totalUnpaidExpensesCashPercentage,
            color: "#494848",
            name: "Unpaid Expenses",
            amount: "€" + this.totalUnpaidExpenses.toFixed(2),
          });
        });
    },
    changed: function () {
      this.fetchStatement();
    },
  },
};
</script>


